export default "__VITE_ASSET__DeRYvVST__"